module.exports = __webpack_public_path__ + "img/katarina_amenities_12.3e2c6e1b.jpg";